// no tracking for now
export const useTryTrackEvent = (eventName: any, eventParams?: Record<string, any>): void => {
  const intercom = useIntercom()
  try {
    intercom.trackEvent(eventName, eventParams)
    console.log('trackEvent success:', eventName, eventParams)
  } catch (e) {
    // console.error('trackEvent error:', e)
  }
}
